import { classnames } from "../../utils/index.jsx";
import { useEffect } from "react";
import styles from "./Img.module.css";
import { IconTrash } from "@tabler/icons-react";
import IconButton from "./IconButton.js";

export default function Img({
  src,
  alt,
  className,
  blob,
  b64data,
  mimetype = "image/jpeg",
  fallback,
  onDelete,
  cover,
  style,
  ...rest
}) {
  let img = null;

  if (blob) {
    src = URL.createObjectURL(blob);
  } else if (b64data) {
    src = `data:${mimetype};base64,${b64data}`;
  } else {
    src = null;
  }

  useEffect(() => {
    return () => {
      if (blob) {
        URL.revokeObjectURL(src);
      }
    };
  }, [blob, src]);

  let isFallback = false;
  if (src) {
    img = (
      <img
        alt={alt}
        className={classnames(cover && styles.cover)}
        src={src}
        {...rest}
      />
    );
  } else {
    img = <span>{fallback}</span>;
    isFallback = true;
  }
  return (
    <div
      className={classnames(
        styles.wrapper,
        isFallback && styles.fallback,
        className,
      )}
      style={style}
    >
      {img}
      {onDelete && (
        <IconButton
          icon={IconTrash}
          onClick={onDelete}
          label="Supprimer"
          className={styles.deleteButton}
        />
      )}
    </div>
  );
}
